module.exports = __webpack_public_path__ + "img/ico6.6c318b27.png";